import { Link } from "react-router";
import { useT, useTurl } from "~/util/Lang";
import css from "./Breadcrumb.module.css";

type Items = {
  title: string;
  url: string;
}[];

export function Breadcrumb(props: { items: Items; noRoot?: true }) {
  const t = useT();
  const turl = useTurl();

  const baseItems = [];
  if (props.noRoot !== true) {
    baseItems.push({
      title: t({ en: "Database", ru: "База знаний" }),
      url: turl("/"),
    });
  }
  const items = baseItems.concat(props.items);

  return (
    <nav className={css.root}>
      <ol itemScope itemType="https://schema.org/BreadcrumbList">
        {items.map((item, i) => (
          <li
            key={i}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link to={item.url} itemProp="item">
              <span itemProp="name">{item.title}</span>
            </Link>
            <meta itemProp="position" content={String(i)} />
          </li>
        ))}
      </ol>
    </nav>
  );
}
